/* Genera 3 tipos de menus: Se recibe un arreglo con el nombre de los menus */

//*componentes-utiles
import GeneraCorreo from "../../../componentes/generaCorreo/GeneraCorreo1";

//*datos
import menuArch from "../../../datos/json/menu.json";

//*clases

//*componente
export default function Ejemplo() {
  let menu = menuArch;
  return (
    <>
      <div className="container container-Vista" >
        <h1>Ejemplo de generación de Correo</h1>
        
        <div className="container-Componente" >  
           <br/>
           <GeneraCorreo />
           <br/>
        </div>   
      </div>
    </>
  );
}
